module.exports = __webpack_public_path__ + "img/l_Docker.0b31d21d.svg";